module.exports = __webpack_public_path__ + "img/busca_github.9a712bbb.jpg";